<template>
    <div class="fuwu-base">
        <router-view/>
        <div v-if="$route.meta.footer.show" class='distributor-footer-wrap'>
            <mt-tabbar v-model='home_selected' fixed class="distributor-footer">
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeWaimaiIndex'}" id='home_waimai'><span :to="{ name: 'HomeWaimaiIndex'}" class='item'><img src="../../assets/image/tab/waimai.svg" class="image" v-if="$route.name=='HomeWaimaiIndex'"><img v-else src="../../assets/image/tab/waimai.svg" class="image" /><span class='text'>{{ $t('menu.waimai') }}</span></span></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='MemberO2oErrand'}" id='member_o2oerrand'><router-link :to="{ name: 'MemberO2oErrand'}" class='item'><img src="../../assets/image/tab/paotui.svg" class="image" v-if="$route.name=='MemberO2oErrand'"><img v-else src="../../assets/image/tab/paotui.svg" class="image" /><span class='text'>{{ $t('menu.o2o_errand') }}</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeIndex'}" id='home_index'>
                  <router-link :to="{ name: 'HomeIndex'}" class='item'>
                    <!-- <img src="../../assets/image/tab/home.gif" class="homeGif" v-if="$route.name=='HomeIndex'">
                    <img v-else src="../../assets/image/tab/home.gif" class="homeGif" />
                    <span class='image'></span> -->
                    <img src="@/assets/image/tab/home.png" class="image" />
                    <span class='text'>{{ $t('menu.home') }}</span>
                  </router-link>
                </mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='MemberOrderList'}" id='member_order'><router-link :to="{ name: 'MemberOrderList'}" class='item'><img src="../../assets/image/tab/dingdan.svg" class="image" v-if="$route.name=='MemberOrderList'"><img v-else src="../../assets/image/tab/dingdan.svg" class="image" /><span class='text'>{{ $t('menu.record') }}</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='MemberIndex'}" id='member_index'><router-link :to="{ name: 'MemberIndex'}" class='item'><img src="../../assets/image/tab/wode.svg" class="image" v-if="$route.name=='MemberIndex'"><img v-else src="../../assets/image/tab/wode.svg" class="image" /><span class='text'>{{ $t('menu.profile') }}</span></router-link></mt-tab-item>
                <!-- <mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeIndex'}" id='home_index'><router-link :to="{ name: 'HomeIndex'}" class='item'><img src="../../assets/image/tab/icon_home_pre.png" class="image" v-if="$route.name=='HomeIndex'"><img v-else src="../../assets/image/tab/icon_home_nor.png" class="image" /><span class='text'>首页</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeWaimaiIndex'}" id='home_waimai'><router-link :to="{ name: 'HomeWaimaiIndex'}" class='item'><img src="../../assets/image/tab/icon_waimai_pre.png" class="image" v-if="$route.name=='HomeWaimaiIndex'"><img v-else src="../../assets/image/tab/icon_waimai_nor.png" class="image" /><span class='text'>点外卖</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='MemberO2oErrand'}" id='member_o2oerrand'><router-link :to="{ name: 'MemberO2oErrand'}" class='item'><img src="../../assets/image/tab/icon_paotui_pre.png" class="image" v-if="$route.name=='MemberO2oErrand'"><img v-else src="../../assets/image/tab/icon_paotui_nor.png" class="image" /><span class='text'>跑腿</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='FuwuIndex'}" id='home_fuwu'><router-link :to="{ name: 'FuwuIndex'}" class='item'><img src="../../assets/image/tab/icon_zhaofuwu_pre.png" class="image" v-if="$route.name=='FuwuIndex'"><img v-else src="../../assets/image/tab/icon_zhaofuwu_nor.png" class="image" /><span class='text'>找服务</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='MemberIndex'}" id='member_index'><router-link :to="{ name: 'MemberIndex'}" class='item'><img src="../../assets/image/tab/icon_wode_pre.png" class="image" v-if="$route.name=='MemberIndex'"><img v-else src="../../assets/image/tab/icon_wode_nor.png" class="image" /><span class='text'>我的</span></router-link></mt-tab-item> -->
            </mt-tabbar>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'FuwuBase',
  data () {
    return {
      home_selected: 'fuwu_index'
    }
  },
  computed: {

  },
  created: function () {

  }
}
</script>
<style lang="scss" scoped>
    .item-wrap{position: relative}
    .image{
      width:1.5rem;
      height:1.5rem;
      display:block;
      margin-left:auto;
      margin-right:auto;
    }
    .homeGif {
      position: absolute;
      top: -23px;
      width: 3.2rem;
      height: auto;
      left: 12%;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
    .icon {
        position: absolute;
        right: 0.8rem;
        top: 0.2rem;
        font-size:$h6;
        line-height: 0.7rem;
        width: 0.9rem;
        height: 0.7rem;
        background: #ef3338;
        border-radius: 1rem;
        text-align: center;
        color: #ffffff;
    }
</style>
